import React,{Fragment, Component} from 'react';
import WOW from 'wowjs';
import Header from './../Layout/Header';
import FooterPremium from './../Layout/FooterPremium';
import PageTitle from './../Layout/PageTitle';

import banner1 from './../../images/main-slider/13new.jpeg';

class Sustainability extends Component{
	componentDidMount(){
		new WOW.WOW().init();	
	}
	render(){
		return(
			<Fragment>
				<style>{`
					.aminite-overlay .overlay-box {
						background: rgb(2 9 33 / 40%);
					}
					.aminite-overlay .overlay-box p {
						color: #ffffff !important;
						opacity: 1 !important;
					}
					/* —— Premium Sustainability page —— */
					.page-sustainability .sustain-intro {
						padding-top: 5rem;
						// padding-bottom: 0.5rem;
					}
					.page-sustainability .sustain-intro .section-head .title {
						letter-spacing: -0.02em;
					}
					.page-sustainability .sustain-intro-eyebrow {
						display: inline-block;
						font-size: 11px;
						font-weight: 600;
						letter-spacing: 0.28em;
						text-transform: uppercase;
						color: #b8975f;
						margin-bottom: 12px;
					}
					.page-sustainability .sustain-intro .section-head p {
						font-size: 17px;
						line-height: 1.85;
						color: #4a4a4a;
						max-width: 520px;
					}
					.page-sustainability .sustain-premium-frame {
						position: relative;
						border-radius: 14px;
						overflow: hidden;
						box-shadow:
							0 32px 64px -16px rgba(15, 23, 42, 0.14),
							0 0 0 1px rgba(184, 151, 95, 0.12);
					}
					.page-sustainability .sustain-premium-frame::before {
						content: "";
						position: absolute;
						inset: 0;
						border-radius: 14px;
						box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
						pointer-events: none;
						z-index: 2;
					}
					.page-sustainability .sustain-premium-frame::after {
						content: "";
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						height: 4px;
						background: linear-gradient(90deg, #b8975f, #d4bc7f, #b8975f);
						z-index: 3;
					}
					.page-sustainability .sustain-premium-frame img {
						width: 100%;
						display: block;
						vertical-align: middle;
						aspect-ratio: 4 / 3;
						object-fit: cover;
					}
					.page-sustainability .sustain-band {
						position: relative;
						padding: 96px 0 88px;
						background:
							linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, transparent 320px),
							radial-gradient(ellipse 80% 50% at 50% -20%, rgba(184, 151, 95, 0.09), transparent),
							linear-gradient(175deg, #faf8f5 0%, #f0ebe4 48%, #e8e2d8 100%);
						overflow: hidden;
					}
					.page-sustainability .sustain-band::before {
						content: "";
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						height: 1px;
						background: linear-gradient(90deg, transparent, rgba(184, 151, 95, 0.35), transparent);
					}
					.page-sustainability .sustain-band-header {
						text-align: center;
						max-width: 720px;
						margin: 0 auto 52px;
					}
					.page-sustainability .sustain-band-eyebrow {
						font-size: 11px;
						font-weight: 600;
						letter-spacing: 0.32em;
						text-transform: uppercase;
						color: #9a7d4a;
						margin-bottom: 16px;
					}
					.page-sustainability .sustain-band-title {
						font-size: clamp(30px, 4.2vw, 52px);
						line-height: 1.12;
						font-weight: 700;
						margin-bottom: 0;
						letter-spacing: -0.02em;
					}
					.page-sustainability .sustain-band-title .gold {
						color: #b8975f;
					}
					.page-sustainability .sustain-band-title .dark {
						color: #1a1a1a;
					}
					.page-sustainability .sustain-band .sustain-title-rule {
						width: 72px;
						height: 3px;
						background: linear-gradient(90deg, #b8975f, #d4bc7f);
						margin: 24px auto 0;
						border-radius: 2px;
					}
					.page-sustainability .sustain-card {
						height: 100%;
						background: #fff;
						border-radius: 14px;
						padding: 36px 32px 40px;
						border: 1px solid rgba(184, 151, 95, 0.18);
						box-shadow:
							0 4px 6px -1px rgba(15, 23, 42, 0.04),
							0 24px 48px -12px rgba(15, 23, 42, 0.08);
						transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.4s ease;
						position: relative;
					}
					.page-sustainability .sustain-card::before {
						content: "";
						position: absolute;
						top: 0;
						left: 24px;
						right: 24px;
						height: 3px;
						border-radius: 0 0 3px 3px;
						background: linear-gradient(90deg, #b8975f, #d4bc7f);
						opacity: 0.95;
					}
					.page-sustainability .sustain-card:hover {
						transform: translateY(-6px);
						box-shadow:
							0 12px 24px -8px rgba(15, 23, 42, 0.1),
							0 40px 64px -16px rgba(15, 23, 42, 0.12);
					}
					.page-sustainability .sustain-card__index {
						font-family: Georgia, "Times New Roman", serif;
						font-size: 13px;
						font-weight: 600;
						letter-spacing: 0.12em;
						color: #b8975f;
						margin-bottom: 14px;
					}
					.page-sustainability .sustain-card__icon {
						display: inline-flex;
						align-items: center;
						justify-content: center;
						width: 48px;
						height: 48px;
						border-radius: 50%;
						background: linear-gradient(145deg, rgba(184, 151, 95, 0.12), rgba(184, 151, 95, 0.04));
						border: 1px solid rgba(184, 151, 95, 0.2);
						color: #9a7d4a;
						font-size: 22px;
						margin-bottom: 20px;
					}
					.page-sustainability .sustain-card h3 {
						font-size: clamp(19px, 2.1vw, 24px);
						font-weight: 700;
						color: #1a1a1a;
						line-height: 1.38;
						margin-bottom: 16px;
						letter-spacing: -0.01em;
					}
					.page-sustainability .sustain-card p {
						font-size: 16px;
						line-height: 1.88;
						color: #555;
						margin-bottom: 0;
					}
					.page-sustainability .sustain-outro {
						margin-top: 48px;
						padding-bottom: 12px;
						background: transparent;
					}
					.page-sustainability .sustain-outro-card {
						max-width: 900px;
						margin-left: auto;
						margin-right: auto;
						text-align: center;
					}
					.page-sustainability .sustain-outro-card .sustain-outro-eyebrow {
						font-size: 11px;
						font-weight: 600;
						letter-spacing: 0.28em;
						text-transform: uppercase;
						color: #9a7d4a;
						margin-bottom: 14px;
					}
					.page-sustainability .sustain-outro-card h3 {
						font-size: clamp(22px, 2.8vw, 30px);
						font-weight: 700;
						color: #1a1a1a;
						margin-bottom: 8px;
						letter-spacing: -0.02em;
					}
					.page-sustainability .sustain-outro-card .sustain-outro-rule {
						width: 56px;
						height: 2px;
						background: linear-gradient(90deg, #b8975f, #d4bc7f);
						margin: 20px auto 24px;
						border-radius: 1px;
					}
					.page-sustainability .sustain-outro-card p:not(.sustain-outro-eyebrow) {
						text-align: center;
					}
					.page-sustainability .sustain-outro-card p + p {
						margin-top: 1.25rem;
					}
					@media (max-width: 991px) {
						.page-sustainability .sustain-band {
							padding: 72px 0 64px;
						}
						.page-sustainability .sustain-card {
							padding: 28px 24px 32px;
						}
					}
				`}</style>
				<Header />
				<div className="page-content bg-white page-sustainability">
					<PageTitle motherMenu="Sustainability" activeMenu="Sustainability" />
					
					{/* Sustainability Section */}
					<section className="content-inner sustain-intro wow fadeIn" data-wow-delay="0.1s" data-content="">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-6 mb-5 mb-lg-0">
									<div className="section-head">
										<span className="sustain-intro-eyebrow wow fadeInUp" data-wow-delay="0.15s">Our approach</span>
										<h2 className="title wow fadeInUp" data-wow-delay="0.2s">Our Commitment to Sustainability</h2>
										<div className="dlab-separator bg-primary wow fadeInUp" data-wow-delay="0.25s"></div>
										<p className="wow fadeInUp" data-wow-delay="0.3s">At Star Giga, we are committed to building sustainable communities that respect the environment and enhance the quality of life for future generations. Our Goldcrest developments incorporate eco-friendly practices and green building technologies.</p>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="sustain-premium-frame wow fadeInRight" data-wow-delay="0.25s">
										<img src={banner1} alt="Star Giga sustainable development" />
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* Sustainability Section End */}
					
					{/* Sustainable Developments Section */}
					<section className="content-inner sustain-band sustainability-developments" data-content=" ">
						<div className="container">
							<header className="sustain-band-header wow fadeInUp" data-wow-delay="0.1s">
								<p className="sustain-band-eyebrow">Vision & responsibility</p>
								<h2 className="sustain-band-title">
									<span className="gold">SUSTAINABLE</span>
									<span className="dark"> DEVELOPMENTS</span>
								</h2>
								<div className="sustain-title-rule" aria-hidden="true" />
							</header>
							<div className="row g-4 g-xl-5 align-items-stretch justify-content-center">
								<div className="col-lg-6">
									<article className="sustain-card wow fadeInUp" data-wow-delay="0.15s">
										<div className="sustain-card__index">01 — Impact</div>
										{/* <div className="sustain-card__icon" aria-hidden="true">
											<i className="las la-globe" />
										</div> */}
										<h3>
											From energy usage to emissions, the construction industry has a huge impact on the environment
										</h3>
										<p>
											The construction sector is one of the largest contributors to global carbon emissions and resource consumption. At Star Giga, we recognize our responsibility to minimize this impact through innovative sustainable practices, renewable energy integration, and eco-friendly building materials in all our Goldcrest developments.
										</p>
									</article>
								</div>
								<div className="col-lg-6">
									<article className="sustain-card wow fadeInUp" data-wow-delay="0.25s">
										<div className="sustain-card__index">02 — Commitment</div>
										{/* <div className="sustain-card__icon" aria-hidden="true">
											<i className="las la-city" />
										</div> */}
										<h3>
											As a fast-growing real estate developer
										</h3>
										<p>
											We are committed to integrating sustainable practices into every aspect of our operations. Our commitment extends from the initial planning stages through construction and into the long-term management of our properties. We prioritize renewable energy sources, sustainable materials, and innovative technologies that reduce environmental impact while enhancing the quality of life for our residents.
										</p>
									</article>
								</div>
							</div>
						</div>
						<div className="sustain-outro">
							<div className="container">
								<article className="sustain-card sustain-outro-card wow fadeInUp" data-wow-delay="0.2s">
									<p className="sustain-outro-eyebrow">Looking ahead</p>
									<h3>Sustainable construction</h3>
									<div className="sustain-outro-rule" aria-hidden="true" />
									<p>
										Sustainable construction is a long-term journey, not a destination. Our goal is to become one of the top developers of sustainable buildings in the UAE over the next 10 years, setting new standards for environmental responsibility in real estate development.
									</p>
									<p>
										We regularly update our progress and initiatives through our website, blog, newsletter, and press releases. Stay connected with us to learn about our latest sustainable innovations and achievements in creating greener communities.
									</p>
								</article>
							</div>
						</div>
					</section>
					{/* Sustainable Developments Section End */}
					
					{/* Parallax video sections — disabled (replaced by balanced layout above)
					<section>
						<div className="aminite-overlay parallax" style={{position: 'relative', overflow: 'hidden'}}>
							<video 
								autoPlay 
								loop 
								muted 
								playsInline
								style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									objectFit: 'cover',
									zIndex: 0
								}}
							>
								<source src={bannerVideo2} type="video/mp4" />
							</video>
							<div className="aminite-over-area" style={{position: 'relative', zIndex: 1}}>
								<div className="overlay-box">
									<h2 className="title">As a fast-growing real estate developer</h2>
									<p>We are committed to integrating sustainable practices into every aspect of our operations. Our commitment extends from the initial planning stages through construction and into the long-term management of our properties. We prioritize renewable energy sources, sustainable materials, and innovative technologies that reduce environmental impact while enhancing the quality of life for our residents.</p>
								</div>
							</div>
						</div>
						<div className="aminite-overlay parallax" style={{position: 'relative', overflow: 'hidden'}}>
							<video 
								autoPlay 
								loop 
								muted 
								playsInline
								style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									objectFit: 'cover',
									zIndex: 0
								}}
							>
								<source src={bannerVideo3} type="video/mp4" />
							</video>
							<div className="aminite-over-area" style={{position: 'relative', zIndex: 1}}>
								<div className="overlay-box">
									<h2 className="title">Sustainable construction</h2>
									<p>Sustainable construction is a long-term journey, not a destination. Our goal is to become one of the top developers of sustainable buildings in the UAE over the next 10 years, setting new standards for environmental responsibility in real estate development.

We regularly update our progress and initiatives through our website, blog, newsletter, and press releases. Stay connected with us to learn about our latest sustainable innovations and achievements in creating greener communities.</p>
								</div>
							</div>
						</div>
					
					</section>
					*/}
					
				</div>
				<FooterPremium />
			</Fragment>
		)
	}
}

export default Sustainability;

